import styled from 'styled-components';
import { Modal } from '@hiiretail/synergy-ui';

export const ModalWrapper = styled(Modal)`
  width: 80vw;
  height: 80vh;
`;
